"use strict";
// packages/types/src/api/record.ts
Object.defineProperty(exports, "__esModule", { value: true });
